module.exports = __webpack_public_path__ + "static/ZenithSlabDJR-Regular-3a70e9b4dba64d6e9e9edaef5b1614fe.woff2";